import styled from 'styled-components'
import { space, fontSize, width, color, fontWeight, borderWidth, borderColor } from 'styled-system'
import { lineHeight, whiteSpace, borderStyle } from './css'

const Li = styled.li`
  ${space} ${whiteSpace} ${lineHeight} ${width} ${color} ${fontWeight} ${fontSize} ${borderStyle} ${borderWidth} ${borderColor};
`

export default Li
